import { render, staticRenderFns } from "./RecognitionS.vue?vue&type=template&id=031a631e&scoped=true"
import script from "./RecognitionS.vue?vue&type=script&lang=js"
export * from "./RecognitionS.vue?vue&type=script&lang=js"
import style0 from "./RecognitionS.vue?vue&type=style&index=0&id=031a631e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "031a631e",
  null
  
)

export default component.exports